import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import client from '../api/client';

const THX_RED = '#B71530';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const userData = await login(email, password);
      // App admin always gets through; others check maintenance status first
      if (userData.role === 'app_admin') {
        navigate('/overview');
        return;
      }
      try {
        const m = await client.get('/maintenance/status');
        if (m.data.maintenance) { navigate('/maintenance'); return; }
      } catch { /* ignore — proceed normally if check fails */ }
      navigate('/overview');
    } catch (err) {
      const msg = err?.response?.data?.detail || 'Login failed. Please check your credentials.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: '#f8f9fa',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div style={{ width: '100%', maxWidth: '420px', padding: '0 16px' }}>
        {/* Header */}
        <div
          style={{
            backgroundColor: THX_RED,
            borderRadius: '12px 12px 0 0',
            padding: '32px',
            textAlign: 'center',
            color: '#fff',
          }}
        >
          <div
            style={{
              width: '60px',
              height: '60px',
              backgroundColor: '#fff',
              borderRadius: '10px',
              margin: '0 auto 16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              color: THX_RED,
              fontSize: '20px',
            }}
          >
            THX
          </div>
          <h2 style={{ margin: 0, fontSize: '22px', fontWeight: '700' }}>AP Automation</h2>
          <p style={{ margin: '4px 0 0', opacity: 0.85, fontSize: '14px' }}>
            Accounts Payable Management
          </p>
        </div>

        {/* Form */}
        <div
          style={{
            backgroundColor: '#fff',
            borderRadius: '0 0 12px 12px',
            padding: '32px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
          }}
        >
          <h3 style={{ marginBottom: '24px', fontSize: '18px', color: '#212529' }}>Sign In</h3>

          {error && (
            <div className="alert alert-danger py-2" style={{ fontSize: '14px' }}>
              <i className="bi bi-exclamation-circle me-2" />
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label fw-semibold" style={{ fontSize: '14px' }}>
                Email Address
              </label>
              <input
                type="email"
                className="form-control"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="you@company.com"
                required
                autoFocus
              />
            </div>
            <div className="mb-4">
              <label className="form-label fw-semibold" style={{ fontSize: '14px' }}>
                Password
              </label>
              <input
                type="password"
                className="form-control"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>
            <button
              type="submit"
              className="btn w-100"
              disabled={loading}
              style={{
                backgroundColor: THX_RED,
                color: '#fff',
                fontWeight: '600',
                padding: '10px',
                border: 'none',
              }}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" />
                  Signing in...
                </>
              ) : (
                'Sign In'
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
